import { api } from './client';

/** Relevo de cola (`relay_cola`, E-012). ADMIN. Prefijo: /api/cola */

export interface VistaConfigRelay {
  configurado: boolean;
  activo: boolean;
  url: string | null;
  channelId: string | null;
  intervaloSegundos: number;
  /** Solo los últimos 4 caracteres: el token entero no sale del servidor. */
  tokenMascara: string | null;
  canal: { id: string; name: string; status: string; simulacro: boolean } | null;
}

export interface GuardarConfigRelay {
  activo: boolean;
  url: string;
  /** Vacío = se conserva el guardado. */
  token?: string | null;
  channelId: string;
  intervaloSegundos: number;
}

export interface ResumenVuelta {
  tomados: number;
  enviados: number;
  fallidos: number;
  frenados: number;
  espera: string | null;
}

export interface EstadoDelRelevo {
  ultimaVuelta: string | null;
  ultimoResumen: ResumenVuelta | null;
  ultimoError: string | null;
  totalEnviados: number;
  totalFallidos: number;
}

export const getConfig = () => api.get<VistaConfigRelay>('/api/cola/config');

export const putConfig = (input: GuardarConfigRelay) =>
  api.put<VistaConfigRelay>('/api/cola/config', input);

export const probarConexion = () => api.post<{ ok: boolean; mensaje: string }>('/api/cola/probar');

export const getEstado = () => api.get<EstadoDelRelevo>('/api/cola/estado');

/** Las métricas del WhatsApp del negocio. Ver `metricas-whatsapp.service.ts`. */
export interface MetricasWhatsApp {
  dias: number;
  personasQueEscribieron: number;
  mensajesEntrantes: number;
  respuestasEnviadas: number;
  enviosFallidos: number;
  /** De 0 a 1. `null` si nadie escribió. */
  tasaDeRespuesta: number | null;
  minutosMedianosDeRespuesta: number | null;
  pidieronPase: number;
  bajas: number;
  porDia: Array<{ dia: string; entrantes: number; respuestas: number }>;
  esperando: Array<{ conversationId: string; quien: string; desde: string }>;
}

export const getMetricas = () => api.get<MetricasWhatsApp>('/api/cola/metricas');
